import { useEffect, useState } from "react";

const FAQSection = () => {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    fetch("/faqs.json")
      .then((res) => res.json())
      .then((data) => setFaqs(data))
      .catch((err) => console.error("Failed to load FAQs:", err));
  }, []);

  if (!faqs.length) return null;

  return (
    <section className="relative py-10 bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 overflow-hidden">
      
      {/* ========== BACKGROUND DECORATION ========== */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-gradient-to-br from-indigo-300 to-purple-300 rounded-full filter blur-3xl opacity-30 animate-pulse" />
        <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] bg-gradient-to-tl from-purple-300 to-pink-300 rounded-full filter blur-3xl opacity-30 animate-pulse" style={{ animationDelay: "1s" }} />
      </div>

      <div className="relative max-w-5xl mx-auto px-6 lg:px-8">
        
        {/* ========== HEADER ========== */}
        <header className="text-center mb-20">
          
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-white rounded-full shadow-lg border-2 border-purple-200 mb-8">
            <span className="text-2xl">❓</span>
            <span className="text-sm font-bold text-purple-600 uppercase tracking-wider">
              Got Questions?
            </span>
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-6">
            Frequently Asked{" "}
            <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
              Questions
            </span>
          </h2>

          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Quick answers to common questions about our classes, certificates, and learning format.
          </p>
        </header>

        {/* ========== FAQ ACCORDION ========== */}
        <div className="space-y-6">
          {faqs.map((faq, i) => {
            const isOpen = open === i;

            return (
              <article
                key={i}
                className={`
                  relative bg-white rounded-3xl shadow-2xl overflow-hidden
                  transition-all duration-500
                  ${
                    isOpen
                      ? "border-4 border-gradient-to-r from-indigo-500 to-purple-500 shadow-indigo-500/30"
                      : "border-4 border-blue-100 hover:border-indigo-300"
                  }
                `}
              >
                {/* Question Button */}
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-6 p-8 text-left group"
                  aria-expanded={isOpen}
                >
                  
                  {/* Number Badge */}
                  <div className={`
                    flex-shrink-0 w-14 h-14 rounded-2xl flex items-center justify-center font-black text-xl shadow-xl
                    transition-all duration-500
                    ${
                      isOpen
                        ? "bg-gradient-to-br from-indigo-500 to-purple-500 text-white scale-110"
                        : "bg-blue-100 text-blue-600 group-hover:bg-indigo-100 group-hover:text-indigo-600"
                    }
                  `}>
                    {String(i + 1).padStart(2, "0")}
                  </div>

                  {/* Question Text */}
                  <span className={`
                    flex-1 text-xl font-bold
                    transition-colors duration-300
                    ${
                      isOpen
                        ? "text-indigo-600"
                        : "text-gray-900 group-hover:text-indigo-600"
                    }
                  `}>
                    {faq.q}
                  </span>

                  {/* Toggle Icon */}
                  <div className={`
                    flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center font-black text-3xl
                    transition-all duration-500
                    ${
                      isOpen
                        ? "bg-gradient-to-br from-indigo-500 to-purple-500 text-white rotate-45 scale-110"
                        : "bg-blue-100 text-blue-600 group-hover:bg-indigo-100 group-hover:text-indigo-600"
                    }
                  `}>
                    +
                  </div>
                </button>

                {/* Answer Section */}
                {isOpen && (
                  <div className="px-8 pb-8 animate-fade-in">
                    <div className="pl-20 pr-4 pt-4 border-t-2 border-blue-100">
                      <p className="text-gray-700 leading-relaxed text-lg">
                        {faq.a}
                      </p>
                    </div>
                  </div>
                )}
              </article>
            );
          })}
        </div>

        {/* ========== BOTTOM CTA ========== */}
        {/* <div className="mt-20 text-center">
          <div className="inline-block bg-white rounded-3xl p-10 shadow-2xl border-4 border-purple-100">
            <p className="text-2xl font-black text-gray-900 mb-4">
              Still have questions?
            </p>
            <p className="text-gray-600 mb-8 max-w-md mx-auto">
              We're here to help! Reach out to our team for personalized assistance.
            </p>
            <a
              href="/contact"
              className="inline-block px-10 py-5 text-lg font-bold text-white bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl shadow-2xl shadow-purple-500/50 hover:shadow-purple-500/70 hover:scale-110 transition-all duration-300"
            >
              Contact Us →
            </a>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default FAQSection;




// import { useEffect, useState } from "react";

// const FAQSection = () => {
//   const [faqs, setFaqs] = useState([]);
//   const [open, setOpen] = useState(null);

//   // Fetch FAQs from public/faqs.json
//   useEffect(() => {
//     fetch("/faqs.json")
//       .then((res) => res.json())
//       .then((data) => setFaqs(data))
//       .catch((err) => console.error("Failed to load FAQs:", err));
//   }, []);

//   if (!faqs.length) return null; // Optional: show nothing while loading

//   return (
//     <section className="py-12 bg-surface" aria-labelledby="faq-heading">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6">

//         {/* ================= SECTION HEADER ================= */}
//         <header className="mb-8 motion-safe:animate-fade-up motion-reduce:animate-none">
//           <h2 id="faq-heading" className="text-2xl sm:text-3xl font-bold text-textPrimary">
//             Frequently Asked Questions
//           </h2>
//           <p className="mt-2 text-textSecondary max-w-2xl">
//             Quick answers to common questions about our classes, certificates, and learning format.
//           </p>
//         </header>

//         {/* ================= FAQ LIST ================= */}
//         <div className="space-y-4">
//           {faqs.map((faq, i) => {
//             const isOpen = open === i;
//             const answerId = `faq-answer-${i}`;

//             return (
//               <article
//                 key={i}
//                 className="border border-border rounded-xl bg-white transition-shadow duration-300 ease-out-soft focus-within:shadow-hover lg:hover:shadow-soft"
//               >
//                 <h3>
//                   <button
//                     type="button"
//                     onClick={() => setOpen(isOpen ? null : i)}
//                     aria-expanded={isOpen}
//                     aria-controls={answerId}
//                     className="w-full flex items-center justify-between px-4 py-4 text-left font-medium text-textPrimary transition-colors duration-250 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-light"
//                   >
//                     <span>{faq.q}</span>
//                     <span
//                       aria-hidden="true"
//                       className={`ml-4 text-primary font-bold transition-transform duration-300 ease-out-soft ${
//                         isOpen ? "rotate-180" : "rotate-0"
//                       } motion-reduce:transition-none`}
//                     >
//                       {isOpen ? "−" : "+"}
//                     </span>
//                   </button>
//                 </h3>

//                 {isOpen && (
//                   <div
//                     id={answerId}
//                     role="region"
//                     className="px-4 pb-4 text-textSecondary text-sm leading-relaxed motion-safe:animate-scale-soft motion-reduce:animate-none will-change-transform"
//                   >
//                     {faq.a}
//                   </div>
//                 )}
//               </article>
//             );
//           })}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default FAQSection;
